module.exports = __webpack_public_path__ + "img/san-marino.624b032c.svg";